/**
 * Configuration file to the codelovers react app.
 *
 * IMPORTANT: this file is referenced by several of the core codelovers
 * modules and should not be removed. All of the flags below are required
 * for proper operation of the libraries.
 */
//import AsyncStorage from '@react-native-community/async-storage';
var platform = "react";

var CLReact = require('cl-react'); // let mixpanel = require('mixpanel-browser');
// let ReactGA = require('react-ga');
//let appConfig = require('./appConfig.json');
//console.log("appConfig",appConfig)


var analyticsIntegrations = {
  platform: platform,
  vendors: {}
};
var segmentIoKey = ""; // if (appConfig.analytics) {
//   if (appConfig.analytics.google_analytics) {
//     analyticsIntegrations.vendors.GOOGLE = {
//       key: appConfig.analytics.google_analytics.key,
//       driver: ReactGA
//     }
//   }
//   if (appConfig.analytics.google_analytics) {
//     analyticsIntegrations.vendors.MIXPANEL = {
//       key: appConfig.analytics.mixpanel.key,
//       driver: mixpanel
//     }
//   }
//   if (appConfig.analytics.segmentio) {
//     segmentIoKey = appConfig.analytics.segmentio.key
//   }
// }

var availableEnvironments = {
  "localhost": "localhost",
  "development": "dev.luboo.com",
  "production": "api.luboo.com",
  "urls": {
    "production": {
      "base_url": "api.luboo.com",
      "api_url": "api.luboo.com",
      "admin_url": "api.luboo.com/admin"
    },
    "development": {
      "base_url": "dev.luboo.com",
      "api_url": "dev.luboo.com",
      "admin_url": "dev.luboo.com/admin"
    }
  }
};
var Config = {
  APP_NAME: "luboo",
  PLATFORM: platform,
  STORAGE: localStorage,
  // Use default localStorage

  /**
   * Defined the available app environments
   * @type {Object}
   */
  AVAILABLE_ENVIRONMENTS: availableEnvironments,

  /**
   * Define the selected environment
   * e.g.'localhost' | 'development' | 'production'
   * @type {String}
   */
  SELECTED_ENV: 'production',

  /**
   * Set to 'true' if you want to cache the cl-api responses
   * @type {Boolean}
   */
  CACHE_API_RESPONSES: true,

  /**
   * Set to 'true' if you want to use SSL/HTTPS
   * @type {Boolean}
   */
  USE_HTTPS: true,

  /**
   * Set production log level
   *  'none' - don't show logs in production
   *  'low' - show only errors and warnings
   *  'high' - show all log levels
   * @type {String}
   */
  PRODUCTION_LOG_LEVEL: 'low' //,
  //SEGMENTIO: { key: segmentIoKey },
  //INTEGRATIONS: new CLReact.CLIntegrations(analyticsIntegrations)

}; // logs:

if (false && Config.SELECTED_ENV === 'production') {
  switch (Config.PRODUCTION_LOG_LEVEL) {
    case 'none':
      console.debug = console.info = console.log = console.warn = console.error = function () {};

      break;

    case 'low':
      console.debug = console.info = console.log = function () {};

      break;

    case 'high':
      break;

    default:
      break;
  }
}

module.exports = Config;